const TripTypeMixin = {
  methods: {
    onTripTypeChanged (newType) {
      this.$store.commit('eHorizonSearchForm/setTripType', newType)
    }
  }
}

export default TripTypeMixin
